/// <amd-module name="TFS/Views/ProjectList/views/ProjectList" />
import React = require("react");

import { ProjectPersona } from "Tfs/Platform/ProjectPersona";
import { ITeamProject } from "TFS/Services/TfsProjectService";
import { InstalledProductsComponent } from "TFS/Views/SuiteMePage/SuiteMePageView/InstalledProducts";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { Components } from "VSS/Platform/Layout";

import { FocusZoneContext } from "VSSUI/FocusZone";
import { IListItemDetails, List, ListItem } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { ScreenSizeConditional } from "VSSUI/Utilities/ScreenSize";

export interface ISuiteProjectListComponentProps {
    projects: ITeamProject[];
}

export class SuiteProjectListComponent extends React.Component<ISuiteProjectListComponentProps, {}> {
    public render(): JSX.Element | null {
        const { projects = [] } = this.props;
        return projects.length ? (
            <List
                className="project-list"
                itemProvider={new ArrayItemProvider<ITeamProject>(projects)}
                pageSize={5}
                renderRow={this._renderRow}
                width="100%"
            />
        ) : null;
    }

    private _renderRow = (index: number, project: ITeamProject, details: IListItemDetails<ITeamProject>) => {
        return (
            <ListItem key={"list-item-" + project.id} className="project-row project-info" details={details} index={index}>
                <FocusZoneContext.Consumer>
                    {cellContext => (
                        <React.Fragment>
                            <a
                                className="project-link flex flex-column flex-grow"
                                href={project.url}
                                data-focuszone={cellContext.focuszoneId}
                                tabIndex={-1}
                            >
                                <div className="top-row flex flex-noshrink">
                                    <ProjectPersona displayName={project.name} size="large" url={project.imageUrl} />
                                    <div className="project-details flex flex-column flex-grow">
                                        <div className="project-name font-size-l font-weight-semibold text-ellipsis">{project.name}</div>
                                        <div className="project-description font-size-m">{project.description}</div>
                                    </div>
                                </div>
                            </a>
                            <ScreenSizeConditional condition={screenSize => screenSize > ScreenSize.xsmall}>
                                <InstalledProductsComponent products={project.products} projectName={project.name} />
                            </ScreenSizeConditional>
                        </React.Fragment>
                    )}
                </FocusZoneContext.Consumer>
            </ListItem>
        );
    };
}

Components.add("tfs-suite-project-list", SuiteProjectListComponent);
